export class StateConstant {
  /* static STATE_BAD_ID = "BAD";
  static STATE_AVERAGE_ID = "AVERAGE";
  static STATE_GOOD_ID = "GOOD";
  static STATE_VERY_GOOD_ID = "VERY_GOOD"; */
  static STATE_OPERATIONAL_ID = "OPERATIONAL";
  static STATE_UNDER_REPAIR_ID = "UNDER_REPAIR";
  static STATE_WAITING_DRIVER_ID = "WAITING_DRIVER";

  static MATERIAL_STATE_OPTIONS = [
    /* { label: "Mauvais", value: this.STATE_BAD_ID },
    { label: "Moyen", value: this.STATE_AVERAGE_ID },
    { label: "Bon", value: this.STATE_GOOD_ID },
    { label: "Très bon", value: this.STATE_VERY_GOOD_ID }, */
    { label: "Opérationnel", value: this.STATE_OPERATIONAL_ID },
    { label: "En réparation", value: this.STATE_UNDER_REPAIR_ID },
    { label: "En attente de conducteur", value: this.STATE_WAITING_DRIVER_ID },
  ];
}

export const getStateTagData = (id: string) => {
  const option = StateConstant.MATERIAL_STATE_OPTIONS.find(
    (opt) => opt.value === id
  );
  let color = "default";
  switch (id) {
    /* case StateConstant.STATE_BAD_ID:
      color = "red";
      break;
    case StateConstant.STATE_AVERAGE_ID:
      color = "orange";
      break;
    case StateConstant.STATE_GOOD_ID:
      color = "blue";
      break;
    case StateConstant.STATE_VERY_GOOD_ID:
      color = "green";
      break; */
    case StateConstant.STATE_OPERATIONAL_ID:
      color = "green";
      break;
    case StateConstant.STATE_UNDER_REPAIR_ID:
      color = "orange";
      break;
    case StateConstant.STATE_WAITING_DRIVER_ID:
      color = "blue";
      break;
  }
  return { label: option?.label || id, color };
};
